export class Filter {
    Property: string | null;
    Value: string | null;
    Value2?: string | null;
    Operator: string | null;
    IsCustomFilter: boolean;
    FilterDataType: string | null;
}